import React from 'react';
import { useSelector } from 'react-redux';
import { Impression } from '@nerdwallet/analytics/react/impression';

import TrackedButton from './TrackedButton';

import { trackInteraction } from '../lib/analytics.helper';
import { GLOBAL_NAV_REG_CTA_V1 } from '../lib/analytics.constants';
import SegmentImpression, {
  ImpressionType,
} from '../../lib/segment/SegmentImpression';
import useAnalytics from '../../lib/segment/useAnalytics';

import styles from './AnonButtons.module.less';
import type { ReduxStore } from '../redux/types';
import { SEGMENT_EVENT } from '@nerdwallet/js-auth-tools/dist/web/new-steps/constants';

const AnonButtons: React.FC = () => {
  const segment = useAnalytics();
  const analyticsBase = GLOBAL_NAV_REG_CTA_V1;
  type ButtonType = 'signin' | 'register';

  const isNWPlusFeatureDiscoveryFlagActive = useSelector<
    ReduxStore,
    ReduxStore['nerdWalletPlusFeatureDiscovery']
  >((store) => store.nerdWalletPlusFeatureDiscovery);

  const featureDiscoveryQueryParam = isNWPlusFeatureDiscoveryFlagActive
    ? '?feature_discovery=nw_plus'
    : '';

  const registerButtonSharedProps = {
    buttonType: 'register' as ButtonType,
    handleClick: () => {
      trackInteraction({
        entityName: analyticsBase.entity_names.register,
        sectionName: analyticsBase.section_name,
        registrationCohort: analyticsBase.cohort,
        action: 'open',
      });
      segment.track(SEGMENT_EVENT.ELEMENT_INTERACTION, {
        entity_name: analyticsBase.entity_names.register,
        section_name: analyticsBase.section_name,
        registration_cohort: analyticsBase.cohort,
      });
    },
    trkLocation: analyticsBase.trk.trk_location,
    cohort: analyticsBase.cohort,
    redirectQueryParam: featureDiscoveryQueryParam,
  };

  return (
    <div className={styles.container}>
      <Impression
        entityName={analyticsBase.entity_names.signin}
        payload={{
          section_name: analyticsBase.section_name,
          registration_cohort: analyticsBase.cohort,
        }}
      >
        <SegmentImpression
          eventName={SEGMENT_EVENT.ELEMENT_IMPRESSION}
          eventType={ImpressionType.TRACK}
          eventProps={{
            entity_name: analyticsBase.entity_names.signin,
            section_name: analyticsBase.section_name,
            registration_cohort: analyticsBase.cohort,
          }}
        >
          <TrackedButton
            buttonName="Sign in"
            buttonType="signin"
            handleClick={() => {
              trackInteraction({
                entityName: analyticsBase.entity_names.signin,
                sectionName: analyticsBase.section_name,
                registrationCohort: analyticsBase.cohort,
                action: 'open',
              });
              segment.track(SEGMENT_EVENT.ELEMENT_INTERACTION, {
                entity_name: analyticsBase.entity_names.signin,
                section_name: analyticsBase.section_name,
                registration_cohort: analyticsBase.cohort,
              });
            }}
            isTertiary
            trkLocation={analyticsBase.trk.trk_location}
          />
        </SegmentImpression>
      </Impression>
      <Impression
        entityName={analyticsBase.entity_names.register}
        payload={{
          section_name: analyticsBase.section_name,
          registration_cohort: analyticsBase.cohort,
        }}
      >
        <SegmentImpression
          eventName={SEGMENT_EVENT.ELEMENT_IMPRESSION}
          eventType={ImpressionType.TRACK}
          eventProps={{
            entity_name: analyticsBase.entity_names.register,
            section_name: analyticsBase.section_name,
            registration_cohort: analyticsBase.cohort,
          }}
        >
          <div className={styles.fullCtaText}>
            <TrackedButton
              isPrimary
              buttonName="Sign up"
              {...registerButtonSharedProps}
            />
          </div>
          <div className={styles.shortCtaText}>
            <TrackedButton buttonName="Join" {...registerButtonSharedProps} />
          </div>
        </SegmentImpression>
      </Impression>
    </div>
  );
};

export default AnonButtons;
